var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"create-puzzle"}},[_c('h2',[_vm._v("Upload New Puzzle")]),_vm._v(" "),_c('puzzle-upload',{on:{"source-file-not-player-compatible":_vm.onSourceFileChange,"puzzle-imported":_vm.onPuzzleImported}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a48c8f86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PuzzleCreate.vue
// module id = 1261
// module chunks = 1